/* global jQuery COMPONENTS */

COMPONENTS.ComponentAccordion = (function ($) {
  function ComponentAccordion () {
    this.$component = $('[data-ecs-component="component-accordion"]')
    this.$accordions = this.$component.find('[data-ecs-components-control="accordion"]')
    this.$categoryButtons = this.$component.find('[data-ecs-accordion-category-control]')
    this.$accordionButtons = this.$component.find('[data-ecs-accordion-control-button]')
    this.$accordionCategories = this.$component.find('[data-ecs-accordion-category]')
  }

  ComponentAccordion.prototype.init = function () {
    const component = this
    let accordion_index = 0

    if (component.$accordions.length < 1) {
      // no accordion on page
      return false
    }
    component.$accordions.accordion()

    component.$accordionButtons.each(function() {
      $(this).attr('data-ecs-accordion-index', accordion_index)
      accordion_index++
    })

    component.$accordionCategories.each(function() {
      const $firstButtonIndex = $(this).find('[data-ecs-accordion-control-button]').first().attr('data-ecs-accordion-index')
      $(this).attr('data-ecs-accordion-first-drawer-index', $firstButtonIndex)
    })

    component.$categoryButtons.click(function () {
      const category = $(this).data('ecs-accordion-category-control')
      $targetAccordion = component.$accordions.filter('[data-ecs-accordion-category="' + category + '"]')
      $targetAccordion.accordion('open', 0)

      $('.ecs__components__accordion__content__wrapper').removeClass('active')
      component.$accordions.each(function () {
        $(this).accordion('close', 'others')
      })
    })
  }

  return ComponentAccordion
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentAccordion = new COMPONENTS.ComponentAccordion()
  COMPONENTS.componentAccordion.init()
})
